<ng-container *ngIf="(formGroup.get(fieldName)?.invalid && (formGroup.get(fieldName)?.dirty || formGroup.get(fieldName)?.touched)) || (formGroup.get(fieldName)?.errors && showErrors)">

  <span *ngIf="formGroup.get(fieldName)?.errors?.required">This field is required</span>

  <ng-container *ngIf="!formGroup.get(fieldName)?.errors?.required">

    <span *ngIf="formGroup.get(fieldName)?.errors['not-specified']">This field is required. </span>

    <span *ngIf="formGroup.get(fieldName)?.errors['not-a-number']">Invalid format. </span>

    <span *ngIf="formGroup.get(fieldName)?.errors.email">Not a valid email address. </span>

    <span *ngIf="formGroup.get(fieldName)?.errors.min || formGroup.get(fieldName)?.errors['min-length']">Must be greater than supplied value. </span>

    <span *ngIf="formGroup.get(fieldName)?.errors.max || formGroup.get(fieldName)?.errors['max-length']">Must be less than supplied value. </span>

    <span *ngIf="formGroup.get(fieldName)?.errors.length">Must meet the required length. </span>

    <span *ngIf="formGroup.get(fieldName)?.errors.maxlength">Must not exceed the specified number of characters. </span>

    <span *ngIf="formGroup.get(fieldName)?.errors.minlength">Must meet the minimum number of characters. </span>

    <span *ngIf="formGroup.get(fieldName)?.errors.pattern">Please enter a valid value. </span>

    <span *ngIf="formGroup.get(fieldName)?.errors.date">Please enter a valid date. </span>

    <span *ngIf="formGroup.get(fieldName)?.errors['older-than']">Must be over 18. </span>

    <span *ngIf="formGroup.get(fieldName)?.errors['abn-invalid']">Invalid ABN. </span>

    <span *ngIf="formGroup.get(fieldName)?.errors['pattern-mismatch']">Please enter valid characters. </span>

    <span *ngIf="formGroup.get(fieldName)?.errors.whitespace">The first character must not be a space. </span>

    <span *ngIf="formGroup.get(fieldName)?.errors.minWords">Must contain at least {{formGroup.get(fieldName)?.errors.minWords}} words. </span>

  </ng-container>
</ng-container>
